'use client';

import { useRef, useEffect } from 'react';
import { usePathname, useRouter } from 'next/navigation';
import { css } from '@bts-web/utils-style-engine';
import { PortfolioLoadingSkeleton } from '../../../portfolio/PortfolioLoadingSkeleton';
import { TransactionStatus } from '@bts-web/data-layer/server';

export function NavigationEvents() {
  const router = useRouter();

  const previousPathNameRef = useRef<string | null>(null);

  const currentPathname = usePathname();

  const shouldRedirect =
    !previousPathNameRef?.current || !currentPathname
      ? false
      : shouldRedirectToPortfolio(previousPathNameRef.current, currentPathname);

  useEffect(() => {
    if (shouldRedirect) {
      router.push('/portfolio');
    }

    previousPathNameRef.current = currentPathname;
  }, [currentPathname, router, shouldRedirect]);

  if (!shouldRedirect) {
    return null;
  }

  return (
    shouldRedirect && (
      <div className={overlayStyle}>
        <PortfolioLoadingSkeleton />
      </div>
    )
  );
}

function shouldRedirectToPortfolio(
  previousPathName: string | undefined,
  currentPathname: string,
) {
  const finishRoutesStates: TransactionStatus[] = [
    'CREATED',
    'IN_PROGRESS',
    'FINISHED',
    'FAILED',
    'EXPIRED',
  ];

  const tradeFinishPartialRoutes = finishRoutesStates.map(
    (status) => `/${status}`,
  );

  // Updated to match the new route structure
  const isAssetTradeRoute = (path: string): boolean => {
    // Check for routes like /assets/{id}/sell/{offerID} or /assets/{id}/buy/{offerID}
    const assetRouteRegex =
      /\/assets\/[^/]+\/(sell|buy|savings)\/[a-zA-Z0-9]{6,}/;

    return assetRouteRegex.test(path);
  };

  if (previousPathName) {
    const isComingFromTradeFinishScreen = tradeFinishPartialRoutes.some((p) =>
      previousPathName.includes(p),
    );

    const isGoingToTradeAcceptScreen = isAssetTradeRoute(currentPathname);

    if (isComingFromTradeFinishScreen && isGoingToTradeAcceptScreen) {
      return true;
    }
  }

  return false;
}

const overlayStyle = css({
  position: 'fixed',
  zIndex: 3,
  backgroundColor: 'screen_background.primary',
  width: '100%',
});
